import type { FortumLogoProps } from '@fortum/elemental-ui'
import { Box, FortumLogo as Logo } from '@fortum/elemental-ui'

export const FortumLogo: React.FC<FortumLogoProps> = ({ 'aria-label': ariaLabel, ...props }) => {
  return (
    <Box position="relative" display="inline-block">
      <Logo
        role="img"
        aria-hidden="true"
        size="s"
        color="currentColor"
        aria-label={ariaLabel}
        {...props}
      />

      {/* Invisible text for screen readers */}
      {ariaLabel && (
        <span
          style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: 0,
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            border: 0,
          }}
          aria-label={ariaLabel}
        >
          {ariaLabel}
        </span>
      )}
    </Box>
  )
}
